import axios from 'axios';
import { AuthProvider, useAuth } from 'oidc-react';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveAccessToken, saveRefreshToken } from './api/api_helper';
import { authApi } from './api/auth';
import appInfo from './app-info';
import LoaderPage from './components/loader-page';
import { authActionTypes } from './state/reducers/authReducer';

const LoginContent = () => {

    const auth = useAuth();
    const { userData, userManager } = auth;
    const id_token = userData ? userData.id_token : "";
    const email = (userData && userData.profile) ? userData.profile.email : "";
    const access_token = userData ? userData.access_token : "";


    const { user } = useSelector(x => x.auth)

    const dispatch = useDispatch();

    useEffect(() => {
        if (access_token && id_token) {
            handleLoginAsync({ access_token, id_token })
        }
    }, [access_token, id_token])
    const handleLoginAsync = async ({ access_token, id_token }) => {
        const res = await authApi.signInSSO({ access_token, id_token });
        if (res.is_success) {
            saveAccessToken(res.data.data.token_info.access_token)
            saveRefreshToken(res.data.data.token_info.refresh_token)
            dispatch({ type: authActionTypes.LOGIN.SUCESS, payload: res.data.data })
        } else {
            alert("Đăng nhập thất bại")
        }
    }
    return (
        <LoaderPage />
    );
}
const UnAuthorizedContent = () => {
    const [appConfig, setAppConfig] = useState();
    const [isLoadingConfig, setIsLoadingConfig] = useState(true);
    console.log({
        oidcConfig: appConfig
    });
    const oidcConfig = useMemo(() => {
        if (!appConfig) {
            // debugger
            return undefined;
        }
        return {
            onSignIn: (e) => {
                // debugger
                console.log({
                    onSignIn: e
                });
            },
            authority: appConfig?.OIDC_AUTHORITY,
            clientId: appConfig?.OIDC_CLIENT_ID,
            redirectUri: appConfig?.OIDC_REDIRECT_URI,
            clientSecret: appConfig?.OIDC_CLIENT_SECRET,
        };
    }, [appConfig])
    useEffect(() => {
        getConfigAsync()
    }, [])
    const getConfigAsync = async () => {
        setIsLoadingConfig(true)
        const res = await axios.get(`${appInfo.api_url}/config`).catch((error) => {
        });
        setIsLoadingConfig(false)
        if (res.data.is_success) {
            localStorage.setItem("home_url", res.data.data.PortalUrl)
            setAppConfig(res.data.data)

        } else {
        }
    }
    return (
        <div>
            {isLoadingConfig && <LoaderPage />}
            {!isLoadingConfig && oidcConfig &&
                <AuthProvider {...oidcConfig} >
                    <LoginContent />
                </AuthProvider>
            }
        </div>
    );
};

export default UnAuthorizedContent;